import { canUseDOM } from './dom';
import globals from '../PageBuilder/globals';

// Representative viewport sizes per device class (from the UA-derived
// deviceType the server puts in the redux Store). Used as the SSR guess and
// the client's identical first render, so hydration stays consistent; the
// real size arrives from resize/mount handlers afterwards.
const DEVICE_SIZES = {
  mobile: { width: 390, height: 844 },
  tablet: { width: 834, height: 1112 },
  desktop: { width: 1366, height: 768 },
};

export const guessedWindowSize = () => DEVICE_SIZES[globals().deviceType] || DEVICE_SIZES.desktop;

export const currentWindowSize = () =>
  canUseDOM() ? { width: window.innerWidth, height: window.innerHeight } : guessedWindowSize();
